import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PasswordConfiguration } from '../api/types';

const usePasswordConfigurationOptions = () => {
    const { t } = useTranslation('common');

    return useMemo(() => {
        const passwordConfigurationOptions = [
            {
                value: PasswordConfiguration.IdentityAndDateOfBirth,
                label: t('common:options.passwordConfiguration.identityAndDateOfBirth'),
            },
            {
                value: PasswordConfiguration.DateOfBirth,
                label: t('common:options.passwordConfiguration.dateOfBirth'),
            },
            {
                value: PasswordConfiguration.Random,
                label: t('common:options.passwordConfiguration.random'),
            },
            {
                value: PasswordConfiguration.Off,
                label: t('common:options.passwordConfiguration.off'),
            },
        ];

        return passwordConfigurationOptions;
    }, [t]);
};

export default usePasswordConfigurationOptions;
